import { USER_PREFERENCES } from "~/constants/storage";
import { UserPreferenceMeasurements } from "~/types/preference";

export const saveUserPreference = (pref: UserPreferenceMeasurements) => {
  if (!pref) {
    return false;
  }
  return localStorage.setItem(USER_PREFERENCES, pref);
};

export const getUserPreference = (): UserPreferenceMeasurements => {
  const pref =
    localStorage.getItem(USER_PREFERENCES) ??
    UserPreferenceMeasurements.Imperial;

  return (
    (pref as UserPreferenceMeasurements) || UserPreferenceMeasurements.Metric
  );
};
